import { render, staticRenderFns } from "./the-appearance-settings-dialog.vue?vue&type=template&id=5643ec16&scoped=true&"
import script from "./the-appearance-settings-dialog.vue?vue&type=script&lang=js&"
export * from "./the-appearance-settings-dialog.vue?vue&type=script&lang=js&"
import style0 from "./the-appearance-settings-dialog.vue?vue&type=style&index=0&id=5643ec16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5643ec16",
  null
  
)

export default component.exports